// 검색·광고·소개 문구에 쓰는 고정 사용자 수. 홈 첫 화면은 서버의 실제 숫자를 따로 보여 준다.
// 실제 숫자가 크게 늘면 이 한 줄만 바꾼다. (2026-09 기준 약 14,500명)
export const TEACHER_COUNT_LABEL = '1만 5천 명';
export const TEACHER_COUNT_LABEL_EN = '15,000+';
